import React, { useState } from 'react';
import { Query } from 'react-apollo';
import { ChartCard } from '..';
import { Measurement } from '../../../lib/helpers/measurement';
import {
  MeasurementsQuery,
  MeasurementsQueryVariables
} from '../../../queries/__generated__/MeasurementsQuery';
import { measurementsQuery } from '../../../queries/measurements';
import { Card, CardSegment, Icon } from '../../ui';
import ErrorScreen from '../../utils/ErrorScreen';
import ChartRollOutCard from '../ChartRollOutCard';

interface IGroupChartListProps {
  notebookId: string;
  subjects: {
    id: string;
    name: string;
    slug: string;
  }[];
  tracker: {
    id: string;
    slug: string;
    type: TrackerType;
    name: string;
    subjects: {
      id: string;
      name: string;
      slug: string;
    }[];
  };
}

const GroupChartList: React.FC<IGroupChartListProps> = ({ tracker, notebookId, subjects }) => {
  const [isOpen, setIsOpen] = useState(false);

  function toggleIsOpen() {
    setIsOpen(!isOpen);
  }

  return (
    <Query<MeasurementsQuery, MeasurementsQueryVariables>
      query={measurementsQuery}
      variables={{
        input: {
          notebookId,
          trackerIds: [tracker.id],
          subjectIds: subjects.map(s => s.id)
        }
      }}
    >
      {({ data, loading, error }) => {
        if (loading) {
          return <div />;
        }

        if (error) {
          return <ErrorScreen error={error.message} />;
        }

        const measurements = data!.measurements.map(m => new Measurement(m));

        return (
          <div className="relative mb2" data-testid={`group-chart-list-${tracker.slug}`}>
            <button
              onClick={toggleIsOpen}
              className="absolute right-0 mr2 mt1"
              data-testid="toggleOpen"
            >
              <Icon name="caret-left" className={isOpen ? 'rotate-90' : 'rotate-270'} />
            </button>

            {!isOpen ? (
              <ChartCard
                measurements={measurements}
                chartType={tracker.type}
                chartTitle={tracker.name}
              />
            ) : (
              <Card className="ph2-m ph3">
                <div className="pt4 ph2">
                  <h3 className="fw6 pb3 mv0">{tracker.name}</h3>
                </div>

                {subjects.map(subject => (
                  <ChartRollOutCard
                    subject={subject}
                    tracker={tracker}
                    notebookId={notebookId}
                    key={`rollout-${subject.id}`}
                  />
                ))}

                {subjects.length < 1 && (
                  <CardSegment className="pt4 pb3 tc light-tan serif i">
                    You haven&rsquo;t recorded any data yet.
                  </CardSegment>
                )}
              </Card>
            )}
          </div>
        );
      }}
    </Query>
  );
};
export default GroupChartList;
